import React from "react";
import {withTranslation} from "react-i18next";

const T = props => {
    return <span>{props.t(props.children)}</span>;
};

export default withTranslation()(T);
